import { mockLuxLoyaltyAccountEligibilityResponse, mockLuxLoyaltyProgramConfigResponse } from 'luxLoyalty/lib/utils'
import requestUtils, { authOptions } from './requestUtils'
import { luxLoyaltyAccountMapper } from './mappers/luxLoyaltyMap'
import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'

type EnrolLuxLoyaltyAccountPayload = paths['/api/lux-loyalty/account']['post']['parameters']['body']['payload']
type EnrolLuxLoyaltyAccountResponse = paths['/api/lux-loyalty/account']['post']['responses']['201']['content']['application/json']
type GetLuxLoyaltyAccountResponse = paths['/api/lux-loyalty/account/me']['get']['responses']['200']['content']['application/json']

const BASE_PATH = '/api/lux-loyalty'

export async function enrolLuxLoyaltyAccountRequest(payload: EnrolLuxLoyaltyAccountPayload) {
  const response = await requestUtils.post<EnrolLuxLoyaltyAccountResponse, EnrolLuxLoyaltyAccountPayload>(`${BASE_PATH}/account?without_brand=1`,
    payload,
    { credentials: 'include' })

  return luxLoyaltyAccountMapper(response.result.accountSummary)
}

export async function fetchLuxLoyaltyAccountRequest(token?: string) {
  const response = await requestUtils.get<GetLuxLoyaltyAccountResponse>(`${BASE_PATH}/account/me`, authOptions(token))

  return luxLoyaltyAccountMapper(response.result.accountSummary)
}

/**
 * @TODO update when svc is ready
 * Possibly will send the email as the payload depending on requirements
 */
export async function fetchLuxLoyaltyAccountEligibilityRequest() {
  return mockLuxLoyaltyAccountEligibilityResponse().result
}

/**
 * @TODO update when svc is ready
 */
export async function fetchLuxLoyaltyProgramConfigRequest() {
  return mockLuxLoyaltyProgramConfigResponse().result
}
